"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StaticListItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
var _ListItemAvatar = require("../ListItemAvatar");
var _ListItemBoxText = _interopRequireDefault(require("../ListItemBoxText"));
var _ListItem = _interopRequireDefault(require("../ListItem"));
var _ListItemIconButton = _interopRequireDefault(require("../ListItemIconButton"));
var _Intl = _interopRequireDefault(require("../../proptypes/Intl"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var StaticListItem = exports.StaticListItem = function StaticListItem(_ref) {
  var avatarProps = _ref.avatarProps,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    disabled = _ref.disabled,
    divider = _ref.divider,
    Icon = _ref.icon,
    iconButtonProps = _ref.iconButtonProps,
    id = _ref.id,
    secondaryText = _ref.secondaryText,
    text = _ref.text,
    textDataTestId = _ref.textDataTestId;
  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    avatarProps: avatarProps,
    className: className,
    dataTestId: dataTestId,
    disabled: disabled,
    divider: divider,
    icon: Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
      htmlColor: disabled ? 'disabled' : "".concat(_js["default"].alias.color.icon.lighter)
    }),
    id: id
  }, /*#__PURE__*/_react["default"].createElement(_ListItemBoxText["default"], {
    text: text,
    secondaryText: secondaryText,
    textDataTestId: textDataTestId,
    hasLeftContent: Boolean(avatarProps) || Boolean(Icon),
    hasRightContent: Boolean(iconButtonProps),
    disabled: disabled
  }), iconButtonProps && /*#__PURE__*/_react["default"].createElement(_ListItemIconButton["default"], _extends({}, iconButtonProps, {
    disabled: disabled
  })));
};
StaticListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _Intl["default"]]).isRequired,
  textDataTestId: _propTypes["default"].string,
  avatarProps: _propTypes["default"].shape(_ListItemAvatar.ListItemAvatarPropTypes),
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  divider: _propTypes["default"].bool,
  icon: _propTypes["default"].elementType,
  iconButtonProps: _propTypes["default"].shape({
    ariaLabel: _propTypes["default"].string.isRequired,
    onClick: _propTypes["default"].func,
    icon: _propTypes["default"].elementType
  }),
  id: _propTypes["default"].string,
  secondaryText: _propTypes["default"].oneOfType([_propTypes["default"].string, _Intl["default"]])
} : {};
var _default = exports["default"] = StaticListItem;